import * as React from 'react';
import Player from './components/Player';

export default function App() {
  return <Player />;
}
